import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import Description from "../components/postDescription/Description";
import RelatedPosts from "../components/relatedPostsList/RelatedPosts";
import { fetchBlog } from "../features/singleBlog/singleBlogSlice";

const Post = () => {
    const {blogId} = useParams();
    const dispatch = useDispatch();

    const {blog, isLoading, isError, error} = useSelector((state) => state.blog);

    useEffect(() => {
        dispatch(fetchBlog(blogId));
    },[dispatch, blogId])

  return isLoading ? <div>Loading...</div> : (
    <>
      <div className="container mt-8">
        <Link
          to='/'
          className="inline-block text-gray-600 home-btn"
          id="lws-goHome"
        >
          <i className="mr-2 fa-solid fa-house"></i>Go Home
        </Link>
      </div>
      <section className="post-page-container">
        <Description blog={blog}/>
        <RelatedPosts id={blog.id} tags={blog.tags}/>
      </section>
    </>
  );
};

export default Post;
